<template>
  <next-double-icon :outer-icon="['fal', 'map-marker']" :inner-icon="innerIcon"/>
</template>

<script>
import NextDoubleIcon from '@/components/validate/NextDoubleIcon.vue';

export default {
  name: 'CustomInnerMarkerIcon',
  components: { NextDoubleIcon },
  props: {
    innerIcon: {
      type: Array,
      default() {
        return ['fal', 'truck'];
      },
    },
  },
};
</script>

<style scoped lang="scss">
.truck_marker{
  position: relative;
  width: 32px;
  height: 32px;
  &__marker{
    width: 32px;
    height: 32px;
    top: 0;
    left: 0;
    position: absolute;
  }
  &__truck{
    width: 16px;
    height: 16px;
    left: 8px;
    top: 4px;
    position: absolute;
  }
}
</style>
